const Mechanical = () => {
  return <h1>Mechanical</h1>;
};

export default Mechanical;
